import React from "react"
import PropTypes from "prop-types"
import { Alert, Button, Flex } from "antd"
import { InfoCircleOutlined } from "@ant-design/icons"
import { Card } from "ui/Card"
import { Text } from "ui/Typography"
import styles from "./BlackOutDates.module.css"

const formatDateRange = (startDate, endDate) => {
  if (!startDate && !endDate) return "—"
  if (startDate && endDate) return `${startDate} – ${endDate}`
  return startDate || endDate
}

const STATIC_BLACKOUT_DATES = [
  { id: 1, title: "Maintenance Days", startDate: "Jul 24, 2026", endDate: "Jul 26, 2026" },
  { id: 2, title: "Weather closures", startDate: "Jun 10, 13" },
]

export const BlackOutDates = ({ blackoutDates = STATIC_BLACKOUT_DATES, onViewGlobalSettings }) => (
  <Card title={"Blackout Dates"} className="mb-3xl">
    <Alert
      type="info"
      showIcon
      icon={<InfoCircleOutlined />}
      className="mb-m"
      message={
        <Flex align="center" gap={4} wrap="wrap">
          <Text>{"These dates are managed globally and may block availability for this experience."}</Text>
          <Button type="link" className="p-0" style={{ height: "auto" }} onClick={onViewGlobalSettings}>
            {"View Global Blackout Settings"}
          </Button>
        </Flex>
      }
    />

    <Flex vertical gap={8}>
      {blackoutDates.map((entry) => (
        <Flex key={entry.id} gap={24} className={styles.dateRow}>
          <Text className={styles.dateTitle}>{entry.title}</Text>
          <Text>{formatDateRange(entry.startDate, entry.endDate)}</Text>
        </Flex>
      ))}
    </Flex>
  </Card>
)

BlackOutDates.propTypes = {
  blackoutDates: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      title: PropTypes.string.isRequired,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
    })
  ),
  onViewGlobalSettings: PropTypes.func,
}
